var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatSports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.6081 0H3.39187C1.5186 0 0 1.51859 0 3.39186V14.6081C0 16.4814 1.5186 18 3.39187 18H14.6081C16.4814 18 18 16.4814 18 14.6081V3.39186C18 1.51859 16.4814 0 14.6081 0Z",
    fill: "url(#paint0_linear_1101_907)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49769 5.4029C6.84991 4.94166 7.2912 4.54612 7.7988 4.23669C7.0918 4.45302 6.4397 4.80272 5.88281 5.26419C5.96099 5.30893 6.04622 5.34187 6.13535 5.3618C6.25489 5.38379 6.376 5.39752 6.49769 5.4029Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18555 5.42821C8.1452 5.38913 9.09991 5.27745 10.0403 5.09428C11.1229 4.88889 12.2471 5.00938 13.2519 5.43849C12.2826 4.5622 11.0027 4.05019 9.65599 4C9.63799 4.02815 9.6141 4.05264 9.58583 4.07205C9.55756 4.09146 9.52544 4.10539 9.49129 4.11302C8.59421 4.31395 7.78748 4.7741 7.18555 5.42821Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3473 11.0904C14.0833 10.7203 13.7613 10.3895 13.3921 10.1091C12.1905 9.19462 10.824 8.48828 9.35699 8.0233C8.3994 7.70382 7.40059 7.50513 6.38693 7.4325C6.38693 7.49414 6.3485 7.56093 6.33203 7.62772C6.91079 7.87302 7.39547 8.27818 7.72099 8.78878C10.142 12.236 12.0306 12.8166 12.9364 12.8525H13.2054C13.7219 12.3926 14.1378 11.8429 14.4297 11.2342L14.3473 11.0904Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.195 5.86469C9.11225 6.08314 8.00864 6.19846 6.90105 6.2089L6.78027 6.41954C7.77639 6.51947 8.7566 6.7281 9.70089 7.04117C11.297 7.54877 12.7841 8.31763 14.0928 9.31191C14.357 9.52305 14.6029 9.75321 14.8285 10.0003C14.8883 9.71576 14.9232 9.42714 14.9328 9.13723C14.9326 8.43032 14.7775 7.73093 14.4771 7.08227C13.3297 6.28082 11.4906 5.6335 10.195 5.86469Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79675 9.36301C6.6309 9.11111 6.41688 8.88994 6.1654 8.71057V9.03937C6.12697 11.0327 6.91753 12.9746 8.12531 13.8788L8.61392 14.2076C9.73824 14.3827 10.8929 14.2152 11.9079 13.7298C10.6616 13.3702 8.86097 12.3016 6.79675 9.36301Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28168 5.79858C5.09083 6.00791 4.91826 6.23126 4.76562 6.46645C5.09947 6.41327 5.43717 6.38407 5.77577 6.37912H5.90753C5.95145 6.29692 5.98988 6.20958 6.0338 6.12738C5.80342 6.08341 5.58376 5.99979 5.38599 5.88078L5.28168 5.79858Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03519 9.019V8.92139C4.96299 9.00947 4.90046 9.10414 4.84854 9.20397C4.60876 9.66367 4.47946 10.1669 4.46973 10.6784V11.3052C4.84278 12.0662 5.40802 12.7309 6.11671 13.242C5.3676 11.9471 4.99468 10.491 5.03519 9.019Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09799 7.59658H5.2023L5.23524 7.46814C4.94243 7.48534 4.65201 7.52834 4.36783 7.59658L4.18666 7.64795C4.09785 7.9318 4.0354 8.22228 4 8.51618C4.24898 8.10576 4.63458 7.7828 5.09799 7.59658Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1101_907",
    x1: 0,
    y1: 0,
    x2: 16,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5270FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8599FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSports);
export default __webpack_public_path__ + "static/media/chat-sports.06bd1aadacd70f67b4db75058c56d642.svg";
export { ForwardRef as ReactComponent };